import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CarauselComp } from 'atoms/Carausel/Presentation/CarauselComp';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import MARKETING_HERO_CONSTANTS from '../Constants/MarketingConstants';
import ChangingProgressProvider from '../ChangingProgressProvider';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import {
  getValueOrDefaultObject,
  getTernaryValue,
  getValueOrEmptyString,
  safeUpperCase,
  getAndCheckIfOneTrue,
  getValuesforProgressProvider,
  getAndCheck,
  getUrlImagePath,
  isElementInViewport,
} from 'common/utilities/utils';
import VideoComponent, { pauseAll } from 'atoms/Video';
import SharedConstants, {
  MP4,
  IMAGE_SIZE_CONSTANTS,
  videoCarouselSpeed,
  imageCarouselSpeedFactor,
} from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { setMarketingAnalyticsOnLoad } from '../MarketingUtilities/marketingUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { WELCOME_TEXT } from 'organisms/PastOrderComponent/Constants/PastOrderConstants';
import { UserOrderContext } from 'context/context';
import { useCarousalDataAU, useShowDisposition } from 'customHooks';
import {
  getCheckTimeSpecificCategoryAvailability,
  getUpdateStoreDetails,
} from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';

export const getPathTransitionDurationSpeed = (videoItem, animationSpeed) => {
  return videoItem ? videoCarouselSpeed : animationSpeed / imageCarouselSpeedFactor;
};

export const RegionalMarketingItems = props => {
  const { SLIDE_CHANGE_INTERVAL, LIGHT, BLACK_COLOR, WHITE_COLOR, IMAGE, WHITE_COLOR_PROPERTY, VIDEO } =
    MARKETING_HERO_CONSTANTS;
  const {
    contentData = [],
    animationSpeed = SLIDE_CHANGE_INTERVAL,
    clickHandler,
    clickImageAnalytics,
    isMobile = false,
    profileReducer,
    userParams,
    isTablet = false,
  } = props;
  const carousal = React.useRef(null);
  const loggedIn = userParams?.loggedIn;
  const [nextSlideIndex, setNextSlideIndex] = useState(0);
  const [transparentImage, setTransparentImage] = useState(false);
  const [fullBleedImage, setFullBleedImage] = useState(false);
  const [imageContainerSize, setImageContainerSize] = useState(0);
  const { MARKETING_ITEMS } = IMAGE_SIZE_CONSTANTS;
  const [videoItem, setVideoItem] = useState(false);
  const tenantData = useSelector(data => data?.tenantReducer);
  const menuReducer = useSelector(data => data?.menuReducer);
  const storeData = useSelector(data => data.menuReducer);
  const cartReducer = useSelector(data => data?.cartReducer);
  const { currencyShortName } = tenantData;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { showDisposition, timeBasedCetegory } = userOrderState;
  const dispatch = useDispatch();
  const getStoreDetail = getUpdateStoreDetails(storeData) || {};
  const pauseCarousel = (analyticsData, ind, item) => {
    const categoryExpried =
      userParams?.localized &&
      getCheckTimeSpecificCategoryAvailability({
        item,
        menuReducer,
        getStoreDetail,
        timeBasedCetegory,
        cartReducer,
        userOrderStateDispatch,
        showModal: true,
        dispatch,
      });
    if (categoryExpried) {
      return;
    }
    carousal.current.slickPause();
    !categoryExpried && clickHandler(analyticsData, ind, null, item);
  };
  const [viewPromotionEventCall, setviewPromotionEventCall] = useState([]);
  useShowDisposition(showDisposition, carousal);
  const viewPromotionsVariables = {
    nextSlideIndex,
    viewPromotionEventCall,
    setviewPromotionEventCall,
    isElementInViewport,
  };
  useCarousalDataAU(
    contentData,
    setMarketingAnalyticsOnLoad,
    setFullBleedImage,
    setTransparentImage,
    setVideoItem,
    currencyShortName,
    viewPromotionsVariables,
  );
  const fetchColor = () =>
    getTernaryValue(contentData[0]?.textColor?.toUpperCase() === LIGHT, 'white-color', 'black-color');

  const getColorBasedOnText = nextIndex => {
    if (contentData[nextIndex].textColor.toUpperCase() !== WHITE_COLOR_PROPERTY) {
      colorChange = 'white-color';
    } else {
      colorChange = 'black-color';
    }
    return colorChange;
  };
  let colorChange = fetchColor();
  const settings = {
    dots: true,
    infinite: true,
    autoplaySpeed: getTernaryValue(contentData?.length === 1, 0, animationSpeed * 970), // converting seconds to milliseconds
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    autoplay: true,
    accessibility: true,
    beforeChange: (currentIndex, nextIndex) => {
      pauseAll();
      carousal.current.slickPlay();
      setNextSlideIndex(getTernaryValue(nextIndex !== contentData.length, nextIndex, 0));
      colorChange = getColorBasedOnText(nextIndex);
      playCarouselVideo(contentData, nextIndex, carousal, isPotrait, isMobile);
    },
    customPaging: currentInd => {
      let currentIndexColor = getColorBasedOnText(nextSlideIndex);
      let incrementedNo = currentInd + 1;
      let formattedNumber = incrementedNo.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
      });
      let progressbar_textcolor = getTernaryValue(colorChange === 'white-color', BLACK_COLOR, WHITE_COLOR);
      return currentInd === nextSlideIndex ? (
        <ChangingProgressProvider values={getValuesforProgressProvider(animationSpeed)}>
          {percentage => (
            <CircularProgressbar
              value={percentage}
              text={formattedNumber}
              styles={buildStyles({
                pathTransitionDuration: getPathTransitionDurationSpeed(videoItem, animationSpeed), // animationSpeed / 4, //10.5,
                textColor: progressbar_textcolor,
                pathColor: progressbar_textcolor,
              })}
              tabIndex='0'
            />
          )}
        </ChangingProgressProvider>
      ) : (
        <div
          className={`${currentIndexColor} carausel-paging`}
          data-testid={`carausel-paging-handler-${currentInd}`}
          onClick={() => setNextSlideIndex(currentInd)}
          aria-label={`Slide ${formattedNumber}`}
          tabIndex='0'
          role='button'
        >
          <span className='carausel-pagingNo'>{formattedNumber}</span>
        </div>
      );
    },
  };
  const [isPotrait, setIspotrait] = useState(getAndCheck(!isTablet, window.innerHeight > window.innerWidth));
  useEffect(() => {
    if ('onorientationchange' in window) {
      window.addEventListener('orientationchange', windowResized);
      return () => {
        window.removeEventListener('orientationchange', windowResized);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const imageSize = getImageSize(MARKETING_ITEMS, isMobile, isTablet);
    setImageContainerSize(imageSize);
    // We only care about the first loaded viewport and not subsequent resizes when calculating imageSize
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const imageSize = getImageSize(MARKETING_ITEMS, isMobile, isTablet);
    setImageContainerSize(imageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, isTablet]);

  const getImageSize = (MARKETING_ITEMS_DATA, isMobileSize, isTabletSize) => {
    const { ITEM_IMAGE_HEIGHT_MOBILE, ITEM_IMAGE_WIDTH_MOBILE, ITEM_IMAGE_HEIGHT_DESKTOP, ITEM_IMAGE_WIDTH_DESKTOP } =
      MARKETING_ITEMS_DATA;
    if (isMobileSize) {
      return { height: ITEM_IMAGE_HEIGHT_MOBILE, width: ITEM_IMAGE_WIDTH_MOBILE };
    } else if (isTabletSize) {
      return { height: ITEM_IMAGE_HEIGHT_MOBILE, width: ITEM_IMAGE_WIDTH_MOBILE };
    } else {
      return { height: ITEM_IMAGE_HEIGHT_DESKTOP, width: ITEM_IMAGE_WIDTH_DESKTOP };
    }
  };
  const windowResized = () => {
    setIspotrait(!isTablet && window.innerHeight < window.innerWidth);
  };

  /* draw carausel component in below header */
  const drawCarausel = () => {
    return contentData.map((item, ind) => {
      const {
        smallText,
        largeText,
        buttonText,
        showButton,
        desktopSrc,
        mobileSrc,
        alt,
        textColor,
        analyticsData,
        noteLine,
        bannerType,
        contentType,
      } = getValueOrDefaultObject(item);
      const imageSrc = getTernaryValue(getAndCheckIfOneTrue(isPotrait, isMobile), mobileSrc, desktopSrc);
      const ariaText = `${buttonText} for ${largeText}`;
      const basicData = profileReducer?.basic;
      return (
        <React.Fragment key={ind}>
          {/*  <div className='marketing-hero' key={ind} onClick={displayButton ? (e) => e.preventDefault() : () => clickImageAnalytics(analyticsData, ind)} style={{
                        backgroundImage: `url(${src})`
                    }
                    }>
                        <div className='carausel-text-span'>
                            <div className='carausel-inner-positions'>
                                {smallText && <div className={`${textColor.toUpperCase() === LIGHT ? 'color-white' : 'color-black'} smallTxtHero`}>{smallText}</div>}
                                {largeText && <div className={`${textColor.toUpperCase() === LIGHT ? 'color-white' : 'color-black'} largeTextHero`}>{largeText}</div>}
                                {displayButton && buttonText &&
                                    <ButtonComp
                                        className={'button redButton carauselOrderNow '}
                                        aria-label={buttonText || ''}
                                        onClickHandler={() => clickHandler(analyticsData, ind)}
                                    >
                                        <span>{buttonText}</span>
                                    </ButtonComp>}
                            </div>
                        </div>
                    </div > */}
          <div
            className={`${getTernaryValue(showButton, 'removePointer marketing-hero-bg-au', 'marketing-hero-bg-au')} ${
              bannerType === VIDEO && 'video-content'
            }`}
            tabIndex='0'
            style={
              bannerType === 'Image' && fullBleedImage
                ? {
                    backgroundImage: `linear-gradient(190.77deg,rgba(32,33,36,0) 21.45%,rgba(32,33,36,.6) 98.01%),url(${imageSrc})`,
                  }
                : {}
            }
            role='clickable image'
            key={ind}
            data-testid={`click-image-analytics-${ind}`}
            onClick={getTernaryValue(
              showButton,
              e => e.preventDefault(),
              () => clickImageAnalytics(analyticsData, ind, item, currencyShortName, clickHandler),
            )}
          >
            {transparentImage && (
              <ImageComponent
                data-testid='image-component'
                srcFile={getUrlImagePath(imageSrc, imageContainerSize.width, imageContainerSize.height)}
                alt={alt}
                className='carausel-image'
              />
            )}
            {bannerType === IMAGE && userParams?.loggedIn && (
              <>
                <div className='strip-continer'>
                  <div className='strip-Icon'>
                    <ImageComponent
                      data-testid='image-strip-component'
                      srcFile={IMAGE_PATH.StripesIcon}
                      className='strip-icon-img'
                    />
                  </div>
                  <div data-testid='greeting-test' className='greeting-heading marketing-hero-greeing'>
                    <span>
                      {translateWithI18Next(WELCOME_TEXT)}, {basicData?.firstName}
                    </span>
                  </div>
                </div>
              </>
            )}

            {bannerType === 'Video' && (
              <VideoComponent
                data-testid='video-component'
                nameSuffix={ind}
                srcFile={imageSrc}
                formatType={contentType}
                className='carausel-video'
              />
            )}
            <div
              className={`market-hero-description grid-container ${loggedIn && 'market-hero-description-signin'} ${
                !transparentImage && 'market-hero-content'
              }`}
            >
              {smallText && !loggedIn && (
                <div className={`color-${textColor.toLowerCase()} smallTxtHero-aus`}>{smallText}</div>
              )}
              {largeText && <div className={`color-${textColor.toLowerCase()} largeTextHero-aus`}>{largeText}</div>}
              {showButton && buttonText && (
                <ContainedButton
                  variant={ButtonType.primary}
                  className={'carauselOrderNow-aus'}
                  aria-label={getValueOrEmptyString(ariaText)}
                  data-testid={`click-handler-${ind}`}
                  onClickHandler={() => pauseCarousel(analyticsData, ind, item)}
                >
                  <span>{buttonText}</span>
                </ContainedButton>
              )}
              {!loggedIn && <div className='marketHero-loader-aus'> </div>}
              <div className={`color-${textColor.toLowerCase()} carauselOrderNow-NoteLine`}>{noteLine}</div>
            </div>
          </div>
        </React.Fragment>
      );
    });
  };
  return (
    <div class={`${transparentImage && 'transperant-img-dots'} ${videoItem && 'videoItem-dots'} `}>
      <CarauselComp carousalRef={carousal} settings={settings}>
        {drawCarausel()}
      </CarauselComp>
    </div>
  );
};
export const playCarouselVideo = async (contentData, currentIndex, carousal, isPotrait, isMobile) => {
  if (contentData && currentIndex >= 0) {
    const { bannerType, mobileSrc, desktopSrc } = contentData[currentIndex];
    if (safeUpperCase(bannerType) === SharedConstants.VIDEO) {
      const videoContainer = document.querySelector(`*[data-index='${currentIndex}']`);
      const videoComp = await videoContainer?.querySelector(`*[id='videoComp${currentIndex}']`);
      console.log('videoComp', videoComp);
      if (videoComp) {
        if (videoComp?.src?.substr(videoComp?.src?.length - 3) !== MP4) {
          console.log('Unknown ===> ', videoComp?.src);
          const imageSrc = getTernaryValue(getAndCheckIfOneTrue(isPotrait, isMobile), mobileSrc, desktopSrc);
          videoComp.src = imageSrc;
          console.log(videoComp);
        }
        videoComp.currentTime = 0;
        videoComp.play();
        // pause the slick slider untill video complete
        carousal.current.slickPause();
        // after video end play the slick slider again
        videoComp.onended = e => {
          carousal.current.slickPlay();
        };
      }
    }
  }
};
export default RegionalMarketingItems;
